import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { MFieldProps } from '../types';
import { FormItem } from './FormItem';
import classNames from 'classnames';
import { Radio as BaseRadio } from '../../radio';

export type RadioProps = MFieldProps<React.ComponentProps<typeof BaseRadio>> & {
  /**
   * Hodnota radia - při vybrání tohoto radia bude mít pole ve formu tuto hodnotu.
   */
  value?: string;
};

export const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
  (
    {
      children,
      name,
      validate,
      className,
      inputClassName,
      contentClassName,
      disabled,
      required,
      label,
      value,
      ...other
    },
    ref
  ) => {
    return (
      <>
        <FormItem
          hideValidationText
          name={name}
          label={false}
          className={classNames('form-radio-item', className)}
          disabled={disabled}
          required={required}
          contentClassName={contentClassName}
        >
          <Field name={name} type={'radio'} value={value}>
            {({
              input: {
                value,
                checked,
                name,
                onChange,
                onFocus,
                onBlur,
                ...nother
              },
              meta,
            }: FieldRenderProps<string>) => {
              return (
                <BaseRadio
                  // name={name}
                  checked={checked}
                  value={value}
                  onChange={onChange}
                  label={label}
                  {...other}
                  {...nother}
                  disabled={disabled || meta.submitting}
                  // @ts-ignore
                  ref={ref}
                  className={classNames(inputClassName)}
                >
                  {children}
                </BaseRadio>
              );
            }}
          </Field>
        </FormItem>
      </>
    );
  }
);
